(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function setupTicker(track) {
      if (!track) return;

      var original = track.querySelector('.announcement-bar__slides:not(.announcement-bar__slides--duplicate)');
      if (!original) return;

      var duplicate = track.querySelector('.announcement-bar__slides--duplicate');

      if (mobileQuery.matches) {
        // On mobile: clone the slides once so the CSS marquee animation loops seamlessly
        if (!duplicate) {
          duplicate = original.cloneNode(true);
          duplicate.classList.add('announcement-bar__slides--duplicate');
          duplicate.setAttribute('aria-hidden', 'true');
          track.appendChild(duplicate);
        }
      } else if (duplicate) {
        // On desktop/tablet: remove the clone, it's not needed
        duplicate.remove();
      }
    }

    function init() {
      document.querySelectorAll('.announcement-bar__track').forEach(setupTicker);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    mobileQuery.addEventListener('change', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
